'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from 'dibs-react-tooltip';
import InfoCircleIcon from 'dibs-vg/dist/react/info-circle';
import InfoCircleFilledIcon from 'dibs-vg/dist/react/info-circle-filled';
import styles from './styles/TradeGuarantee.scss';

import copy from '../../../../../json/copy/pdp.json';

class TradeGuarantee extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isVisible: false
        };

        this.toggleIcon = this.toggleIcon.bind(this);
    }

    toggleIcon() {
        const { isVisible } = this.state;

        this.setState({
            isVisible: !isVisible
        });
    }

    render() {
        const { isVisible } = this.state;
        const { title, tooltip } = copy.guarantee;
        const mainClass = classNames(styles.wrapper, {
            [styles.moveUp]: this.props.moveUp
        });
        const IconView = isVisible ? InfoCircleFilledIcon : InfoCircleIcon;

        return (
            <div className={mainClass}>
                <span className={styles.title}>{title}</span>
                <span
                    className={styles.iconWrapper}
                    onMouseEnter={this.toggleIcon}
                    onMouseLeave={this.toggleIcon}
                >
                    <IconView className={styles.icon} />
                    <Tooltip
                        isVisible={isVisible}
                        className={styles.tooltip}
                        containerClass={styles.tooltipInner}
                    >
                        <div className={styles.tooltipTitle}>{tooltip.title}</div>
                        <div className={styles.tooltipDescription}>{tooltip.description}</div>
                        <a href={tooltip.linkUrl}
                            title={tooltip.linkText}
                            target="_blank"
                        >
                            {tooltip.linkText}
                        </a>
                    </Tooltip>
                </span>
            </div>
        );
    }
}

TradeGuarantee.propTypes = {
    moveUp: PropTypes.bool
};

TradeGuarantee.defaultProps = {
    moveUp: false
};

module.exports = TradeGuarantee;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Sidebar/TradeGuarantee.jsx